import React, { useState } from 'react';

// Material
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import DialogContentText from '@mui/material/DialogContentText';

// Components
import Textfield from '../../../../components/inputs/input';

// Hooks
import useNotify from '../../../../hooks/notify';

const ObservationModal = ({ movement, onChange, onSave, onClose, open }) => {
    const [error, setError] = useState(false);
    const { Notify, variants } = useNotify();

    const handleReasonChange = (e) => {
        setError(!e.target.value);
        onChange({ reason: e.target.value })
    }

    const handleSave = () => {
        if (!movement.reason || movement.reason == null)
            return Notify("Al movimiento le falta una observacion.", variants.ERROR);
        
        onSave();
        onClose();
    }

    return (
        <Dialog
            open={open}
            onClose={onClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">
                Confirmar Ajuste
            </DialogTitle>
            <DialogContent style={{ minWidth: 430 }}>
                <DialogContentText id="alert-dialog-description">
                    Indique el Motivo por el cual se hace el movimiento.
                </DialogContentText>
                <Textfield
                    required
                    fullWidth
                    multiline
                    rows={5}
                    name='reason'
                    label='Observacion'
                    onChange={handleReasonChange}
                    value={movement.reason} 
                    error={error}
                />
            </DialogContent>
            <DialogActions>
                <Button 
                    onClick={onClose} 
                    color="primary"
                >
                    Cancelar
                </Button>
                <Button 
                    onClick={handleSave} 
                    color="primary" 
                    variant='outlined'
                    autoFocus
                >
                    Guardar
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default ObservationModal;